function EmptyComponent() {
  return <div>No users to display</div>;
}

export default EmptyComponent;
